import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import ContentWrapper from '~/tutor-on-demand/components/Content/ContentWrapper'
import HeaderTitle from '~/tutor-on-demand/components/Header/HeaderTitle'
import HeaderWrapper from '~/tutor-on-demand/components/Header/HeaderWrapper'
import List from '~/tutor-on-demand/components/Typography/List'
import TutorOnDemandProductCards from '~/shared/components/TutorOnDemandProductCards/TutorOnDemandProductCards.component'
import Paragraph from '~/tutor-on-demand/components/Typography/Paragraph'
import SubContainer from '~/tutor-on-demand/components/Content/SubContainer'
import SubContainerWrapper from '~/tutor-on-demand/components/Content/SubContainerWrapper'
import { SubjectType, getSubjectImage } from '~/components/Metadata/SubjectMetatags'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

import ROUTES from '~/shared/constants/routes.const'
import BreadCrumbs from '~/encyclopedia/components/BreadCrumbs'

enum Topic {
  ECONOMY_AND_MARKETS = 'economy-and-markets',
  TECHNOLOGY = 'technology',
  PORTFOLIO_MANAGEMENT = 'portfolio-management',
  STRATEGIC_DECISIONS = 'strategic-decisions',
}

export default function TutorOnDemandFinance({ type }: { type: SubjectType }): React.ReactElement {
  const isSmallScreen = useCheckBreakpoint({ lt: Breakpoint.XL })
  const { t } = useTranslation(['tutorOnDemand', 'tutorOnDemandFinance'])
  const breadcrumbs = [
    { path: ROUTES.TUTOR_ON_DEMAND_INFORMATION, h1: t('tutorOnDemand:landingPage.whatIsTutorOnDemand.title') },
    { path: ROUTES.TUTOR_ON_DEMAND_FINANCE, h1: t('tutorOnDemandFinance:title') },
  ]

  return (
    <Fragment>
      <HeaderWrapper>
        <BreadCrumbs
          breadcrumbs={breadcrumbs}
          fontSize="medium"
          isWhite
          itemClassNames="font-medium items-center"
          wrapperClassNames="mt-1 pr-12 lg:pr-0"
        />

        <HeaderTitle
          iconAlt={getSubjectImage(type, t).alt as string}
          iconSrc={getSubjectImage(type, t).srcKey as string}
        >
          {t('tutorOnDemandFinance:title')}
        </HeaderTitle>
      </HeaderWrapper>
      <ContentWrapper className="space-y-8">
        <div className="xl:space-x-8 xl:flex">
          <section className="mb-6 space-y-6 xl:mb-0">
            <Paragraph>{t('tutorOnDemandFinance:contentParagraph1')}</Paragraph>
            <Paragraph>{t('tutorOnDemandFinance:contentParagraph2')}</Paragraph>
            <Paragraph>{t('tutorOnDemandFinance:contentParagraph3')}</Paragraph>
            {!isSmallScreen && (
              <TutorOnDemandProductCards
                className="pt-8 max-w-max space-y-14 lg:space-y-0 lg:space-x-4 xl:space-x-8 flex flex-col lg:flex-row"
                colorScheme="white"
                hideChatWithTutor
                hideVideoChatWithTutor
              />
            )}
          </section>
          <SubContainerWrapper>
            <SubContainer className="w-full max-w-sm" header={t('tutorOnDemandFinance:weCanHelpYouWith.header')}>
              <List
                items={Object.values(Topic).map((item) => t(`tutorOnDemandFinance:weCanHelpYouWith.items.${item}`))}
              />
            </SubContainer>
          </SubContainerWrapper>
        </div>
        {isSmallScreen && (
          <TutorOnDemandProductCards
            className="pt-8 max-w-max space-y-14 lg:space-y-0 lg:space-x-4 xl:space-x-8 flex flex-col lg:flex-row"
            colorScheme="white"
            hideChatWithTutor
            hideVideoChatWithTutor
          />
        )}
      </ContentWrapper>
    </Fragment>
  )
}
